<template>
  <div id="confirm-your-mail">
    <section class="hero is-fullheight">
        <div class="hero-body">
          <div class="container has-text-centered">
            <div class="column is-8 is-offset-2">
              <span class="icon has-text-warning">
                <i class="fas fa-6x fa-exclamation-circle"></i>
              </span>
              <h3 class="title has-text-grey" style="margin-top: 24px;">Please confirm your email first!</h3>
              <p class="subtitle has-text-grey">Email confirmation has been sent to your email account (<b class="has-text-primary">{{ me.email }}</b>). Please log in to your email account, check for new mail (also check <b class="has-text-danger">Promotion</b> and <b class="has-text-danger">Spam</b> folders), open it and click on <b>"Confirm Email"</b> button.</p>
              <p class="subtitle has-text-grey">When you confirm your email, you can click on button below to go back on homepage.</p>
              <div class="buttons" style="margin-bottom: 24px;">
                <a href="/dashboard/profile" class="button">
                  Go back to homepage
                </a>
              </div>
              <p class="subtitle has-text-grey">Or you can logout.</p>
              <button class="button is-danger" @click="logout">
                <span class="icon">
                  <i class="fa fa-power-off"></i>
                </span>
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </section>
  </div>
</template>

<script>
import Vue from 'vue'
import global from './mixins/globalMixins'

export default {
  mixins : [global],
  data() {
    return {
      me: {
        profile: {}
      },
    }
  },
  created() {
    let self = this;
    if(this.$me.id != -1) {
      this.me = this.$me;
    } else {
      this.userRepo.me().then(response => {
        Vue.prototype.$me = response.data.data;
        this.me = this.$me;
      });
    }
  },
  methods: {
    logout: function () {
        let component = this;
        this.$auth.logout().then(function () {
            component.$router.push('/');
        }).catch(function(){
            component.$router.push('/');
        }).finally(function() {
            Vue.prototype.$me = {
                price: 0,
                user: {
                    profile: {
                        name: ''
                    },
                    news : [],
                    unseenNews :[]
                },
                id: -1
            };
        });
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/ConfirmYourMail.vue